import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-classification',
  templateUrl: './classification.component.html',
  styleUrls: ['./classification.component.scss'],
})
export class ClassificationComponent implements OnInit {

  @Input() public classification: string = '';

  constructor() { }

  ngOnInit() {}

}
